import styled from 'styled-components'

export const BoxesContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp16};
`

export const AlertSlot = styled.div`
  margin-top: ${props => props.theme.spacing.sp16};
`

export const Actions = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp8};
  margin-top: ${props => props.theme.spacing.sp16};
`
